
angular.module('bmsApp.employee').controller('EmployeeMainCtrl', [
	'$scope', '$state', function (
		$scope, $state) {
		
		$scope.$on('employeeIndexUpdated', function (e, employeeData) {
			$scope.employees = employeeData.employee_collection;
			$scope.employeeTotalCount = employeeData.employee_total_count;
		});

		$scope.employeeIndex = {
			totalCount: 0,
			resultCount: 0
		};

		$scope.statistics = {
			total: null,
			active: null,
			inactive: null,
			retention_rate: null
		};

		$scope.exportEmployees = function () {
			$scope.$broadcast('employeeIndexExport', {});
		};

		$scope.importEmployees = function () {
			$state.go('main.employee.import');
		};

		$scope.trainingModalSelected = function (name) {
			$scope.$broadcast('trainingModalSelected', {
				name: name
			});
		};
		
	}]);
